import { render } from "./forbidden.html?vue&type=template&id=d2db4af0&ts=true"
import script from "./forbidden.ts?vue&type=script&lang=ts"
export * from "./forbidden.ts?vue&type=script&lang=ts"

import "./forbidden.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__